// import React from 'react';
// import { Button } from 'react-bootstrap';
// const CustomNavbar = ({ onToggleSidebar }) => {
//   return (
//     <div className="custom-navbar d-flex justify-content-between align-items-center">
//       <div className="d-flex align-items-center">
//         <img src="assets/img/ownx_logo_light_720.png" height={40}  alt="" />
//       </div>
//       <div className="d-flex align-items-center gap-2">
//         <Button variant="primary" size="sm">
//           Connect Wallet
//         </Button>
//         <button
//           className=" btn-outline-primary d-md-none"
//           onClick={onToggleSidebar}
//         >
//           <i className="bi bi-list fs-4"></i>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CustomNavbar;

import React from 'react';
import { Button } from 'react-bootstrap';
const CustomNavbar = ({ onToggleSidebar }) => {
  return (
    <div className="custom-navbar d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
      <img src="/assets/img-1/ownx.png" alt="Logo" height="40" class="d-block d-md-none" />

      </div>
      <div className="d-flex align-items-center gap-2">
        <Button variant="primary" size="sm">
          Connect Wallet
        </Button>
        <button
          className="btn btn-outline-primary d-md-none"
          onClick={onToggleSidebar}
        >
          <i className="bi-list fs-4" style={{color:'#0061fe'}}></i>
        </button>
      </div>
    </div>
  );
};

export default CustomNavbar;
